import ConnectionRequestsDashboard from "./ConnectionRequestsDashboard"

export default  ConnectionRequestsDashboard;



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/index.js